module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The Society for American Baseball Research (SABR) bio project is a national baseball treasure, and "), _c('a', {
    attrs: {
      "href": "http://baseballreference.com",
      "target": "_blank"
    }
  }, [_vm._v("baseballreference.com")]), _vm._v(" is a constant source of both information and amazement both were an integral part of this story. Nothing brings a clearer perspective than to read about people and the events they create as they happened; "), _c('a', {
    attrs: {
      "href": "http://newspapers.com",
      "target": "_blank"
    }
  }, [_vm._v("newspapers.com")]), _vm._v(" allows that to happen, and for that, we are grateful. Quotes contained herein came from biographies, newspapers, magazines, and previously recorded interviews. The treasure trove that is the National Baseball Hall of Fame website contributed as well. Thanks to Mark Guthrie for his insights and Rachael Adams for hers. And as always Lynda, "), _c('i', [_vm._v("sei la mia anima e i miei cuori ispirazione")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All the photographs of hall of fame plaques were taken by David Hickey. Unless otherwise noted, all the photographs in chapters one and six are from Kerry Keene’s personal collection, those in chapters two and five are from David Hickey’s personal collection, and the images in chapters three and four are from Raymond Sinibaldi’s personal collection. ")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/P6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("On June 12, 1939, the baseball world gathered on the lawn outside the new National Baseball Hall of Fame in Cooperstown, New York. The classes of 1936, 1937, 1938, and 1939, comprising 25 men, were inducted. Two were New York Yankees: Babe Ruth and “Wee Willie” Keeler. Babe was one of the five initial electees in 1936, while Keeler was elected in 1939. Lou Gehrig joined the 1939 class in a unanimous vote of the writers in a special December election. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1789404b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 75
// module chunks = 0